export const scrollResultsToDatasetByParam = () => {
  const params = new URLSearchParams(window.location.search);
  const datasetIdParam = params.get("datasetId") ? decodeURIComponent(params.get("datasetId")) : undefined;

  if (datasetIdParam) {
    const element = document.getElementById(encodeURIComponent(datasetIdParam));
    if (element) {
      element.scrollIntoView();
    }
  }
};
